var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 8.44442C12.3334 7.15576 11.2888 6.11108 10.0001 6.11108C8.71138 6.11108 7.66675 7.15576 7.66675 8.44442C7.66675 9.73312 8.71138 10.7778 10.0001 10.7778C11.2888 10.7778 12.3334 9.73312 12.3334 8.44442Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 14.6667C13.8889 12.519 12.1477 10.7778 9.99997 10.7778C7.8522 10.7778 6.11108 12.519 6.11108 14.6667",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.7778V9.22222C17 6.28904 17 4.82245 16.0888 3.91122C15.1776 3 13.7109 3 10.7778 3H9.22222C6.28904 3 4.82245 3 3.91122 3.91122C3 4.82245 3 6.28904 3 9.22222V10.7778C3 13.7109 3 15.1776 3.91122 16.0888C4.82245 17 6.28904 17 9.22222 17H10.7778C13.7109 17 15.1776 17 16.0888 16.0888C17 15.1776 17 13.7109 17 10.7778Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendors);
export default __webpack_public_path__ + "static/media/vendors.67f513185190a6a3965a892792a3104a.svg";
export { ForwardRef as ReactComponent };